import NewPremiumTierRebrand from '@/assets/image/free-to-pay/new-premium-tier-svg/new-premium-tier-rebrand.svg';
import Image, { type ImageProps } from 'next/image';

export const NewPremiumTierSvg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'new premium tier', ...rest } = props;

  return <Image src={NewPremiumTierRebrand} alt={alt} {...rest} />;
};
